import { render } from "./holder-detail.vue?vue&type=template&id=081944cb"
import script from "./holder-detail.vue?vue&type=script&lang=js"
export * from "./holder-detail.vue?vue&type=script&lang=js"

import "./holder-detail.vue?vue&type=style&index=0&id=081944cb&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__